import { DeleteAggregateBusinessFromGroupRequest } from '@/coreInfrastructureModule/axios/generated/groupManage';

/**
 * 集計からグループを削除するアダプタ
 */
export class DeleteAggregateBusinessGroupAdapter {
  /**
   * リクエストをAPI用に変換する
   * @param aggregateBusinessIds - 集計ID
   * @param groupId - グループID
   */
  public static adaptForRequest(aggregateBusinessIds: string[], groupId: string): DeleteAggregateBusinessFromGroupRequest {
    return {
      deleteAggregateBusinessFromGroupInfo: {
        groupId: groupId,
        aggregateBusinessIds: aggregateBusinessIds,
      },
    };
  }
}
